import React from 'react'
import FinanceChart from './chart'
import FinanceTable from './table'
import withLoadingFeedBack, { PANEL_MIN_HEIGHT } from './withLoadingFeedBack'

const BaseContainer = ({ callApi }) => {
  const typePrefix = callApi.typePrefix
  return (
    <div className="flexColumn" style={{ minHeight: PANEL_MIN_HEIGHT }}>
      <FinanceChart typePrefix={typePrefix} />
      <FinanceTable typePrefix={typePrefix} />
    </div>
  )
}

export default withLoadingFeedBack(BaseContainer)
